<section class="open-enrollment-banner" [style.background]="getBackground()">
    <div class="open-enrollment-banner__container">
        <!-- Left Column: Subtitle and Date Range -->
        <div class="open-enrollment-banner__left">
            @if (block.data.Subtitle) {
                <p class="open-enrollment-banner__subtitle">{{ block.data.Subtitle }}</p>
            }
            @if (formattedDateRange) {
                <h1 class="open-enrollment-banner__date-range">{{ formattedDateRange }}</h1>
            }
        </div>

        <!-- Right Column: Title, Description, and CTA -->
        <div class="open-enrollment-banner__right">
            @if (block.data.title) {
                <h2 class="open-enrollment-banner__title">{{ block.data.title }}</h2>
            }
            @if (block.data.text) {
                <div class="open-enrollment-banner__text" [innerHTML]="block.data.text"></div>
            }
            @if (block.data.url) {
                @if (isExternalLink(block.data.url)) {
                    <a
                        [href]="block.data.url"
                        [attr.aria-label]="block.data.linkAriaLabel"
                        [attr.target]="block.data.externalLink ? '_blank' : '_self'"
                        [attr.rel]="block.data.externalLink ? 'noopener noreferrer' : null"
                        class="open-enrollment-banner__button">
                        <span>{{ block.data.buttonText || 'Learn More' }}</span>
                        @if (block.data.buttonIcon_url || block.data.buttonIcon) {
                            <img
                                [src]="block.data.buttonIcon_url || block.data.buttonIcon"
                                alt=""
                                class="open-enrollment-banner__button-icon" />
                        } @else {
                            <svg
                                class="open-enrollment-banner__button-icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5 12H19M19 12L12 5M19 12L12 19"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        }
                    </a>
                } @else {
                    <a
                        [routerLink]="block.data.url"
                        [attr.aria-label]="block.data.linkAriaLabel"
                        [attr.target]="block.data.externalLink ? '_blank' : '_self'"
                        [attr.rel]="block.data.externalLink ? 'noopener noreferrer' : null"
                        class="open-enrollment-banner__button">
                        <span>{{ block.data.buttonText || 'Learn More' }}</span>
                        @if (block.data.buttonIcon_url || block.data.buttonIcon) {
                            <img
                                [src]="block.data.buttonIcon_url || block.data.buttonIcon"
                                alt=""
                                class="open-enrollment-banner__button-icon" />
                        } @else {
                            <svg
                                class="open-enrollment-banner__button-icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5 12H19M19 12L12 5M19 12L12 19"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        }
                    </a>
                }
            }
        </div>
    </div>
</section>
